/**
 * RETIRED: Quiz V2 runtime lives in apps/entries/naked-quiz-v2.tsx (+ editor entry).
 * This jQuery metafield filter is no longer loaded by layout/theme.liquid.
 * Kept temporarily for reference / rollback only.
 */
$(document).ready( function() {
  
  var $naked_quiz = $('#nakedQuiz');

  function getAnalytics() {
    return window.NakedQuizAnalytics || null;
  }

  function analyticsCapture(eventName, props) {
    var analytics = getAnalytics();
    if (!analytics || typeof analytics.capture !== 'function') return;
    analytics.capture(eventName, props);
  }

  function analyticsCaptureOnce(key, eventName, props) {
    var analytics = getAnalytics();
    if (!analytics || typeof analytics.captureOnce !== 'function') return;
    analytics.captureOnce(key, eventName, props);
  }

  function stepAnalyticsMeta(stepId) {
    var analytics = getAnalytics();
    if (analytics && typeof analytics.stepMeta === 'function') {
      return analytics.stepMeta(stepId);
    }
    return { step_name: stepId || 'unknown', step_index: null };
  }

  function trackStepViewed(stepId) {
    var meta = stepAnalyticsMeta(stepId);
    if (stepId && stepId !== 'landing') {
      analyticsCaptureOnce('started', 'Quiz Started', {
        step_name: meta.step_name,
        step_index: meta.step_index,
      });
    }
    analyticsCaptureOnce('viewed:' + meta.step_name, 'Quiz Step Viewed', {
      step_name: meta.step_name,
      step_index: meta.step_index,
    });
  }

  function trackStepCompleted($step) {
    var stepId = ($step.attr('id') || '').replace('nakedQuizStep-', '');
    var meta = stepAnalyticsMeta(stepId);
    var answerCount = $step.find('.naked-option-input:checked').length;
    analyticsCaptureOnce('completed:' + meta.step_name, 'Quiz Step Completed', {
      step_name: meta.step_name,
      step_index: meta.step_index,
      answer_count: answerCount,
    });
  }

  analyticsCaptureOnce('viewed', 'Quiz Viewed', {
    step_name: 'landing',
    step_index: 0,
  });
  analyticsCaptureOnce('viewed:landing', 'Quiz Step Viewed', {
    step_name: 'landing',
    step_index: 0,
  });
  
  function load_quiz_results() {
    $naked_quiz.addClass('quiz-loading-results');
    
    var recommended_products = [];
    
    var recommended_products_age = [];
    var recommended_products_gender = [];
    var recommended_products_bodygoal = [];
    var recommended_products_lifestylegoal = [];
    var recommended_products_athlete = [];
    var recommended_products_diet = [];
    var recommended_products_restriction = [];
    var recommended_products_flavor = [];
    
    $('.recommendedProduct').each( function() {
      var product_handle = $(this).attr('data-product-handle');
      
      var recommend_based_on_age = true,
          recommend_based_on_gender = true,
          recommend_based_on_bodygoal = true,
          recommend_based_on_lifestylegoal = false,
          recommend_based_on_athlete = true,
          recommend_based_on_diet = true,
          recommend_based_on_restriction = true,
          recommend_based_on_flavor = true;
      
      var naked_quiz_age = $(this).attr('data-quiz-age'),
          naked_quiz_gender = $(this).attr('data-quiz-gender'),
          naked_quiz_bodygoal = $(this).attr('data-quiz-bodygoal'),
          naked_quiz_lifestylegoal = $(this).attr('data-quiz-lifestylegoal'),
          naked_quiz_athlete = $(this).attr('data-quiz-athlete'),
          naked_quiz_diet = $(this).attr('data-quiz-diet'),
          naked_quiz_restriction = $(this).attr('data-quiz-restriction'),
          naked_quiz_flavor = $(this).attr('data-quiz-flavor');
      
      if(naked_quiz_age != '') {
        console.log(product_handle + ' has meta for naked_quiz_age: ' + naked_quiz_age);
        $('input.naked_quiz_age:checked').each( function() {
          if(naked_quiz_age.includes($(this).val())) {
            recommended_products_age.push(product_handle);
          } else {
            recommend_based_on_age = false;
          }
        });
      }
      
      if(naked_quiz_gender != '') {
        console.log(product_handle + ' has meta for naked_quiz_gender: ' + naked_quiz_gender);
        $('input.naked_quiz_gender:checked').each( function() {
          if(naked_quiz_gender.includes($(this).val())) {
            recommended_products_gender.push(product_handle);
          } else {
            recommend_based_on_gender = false;
          }
        });
      }
      
      if(naked_quiz_bodygoal != '') {
        console.log(product_handle + ' has meta for naked_quiz_bodygoal: ' + naked_quiz_bodygoal);
        $('input.naked_quiz_bodygoal:checked').each( function() {
          if(naked_quiz_bodygoal.includes($(this).val())) {
            recommended_products_bodygoal.push(product_handle);
          } else {
            recommend_based_on_bodygoal = false;
          }
        });
      }
      
      if(naked_quiz_lifestylegoal != '') {
        console.log(product_handle + ' has meta for naked_quiz_lifestylegoal: ' + naked_quiz_lifestylegoal);
        $('input.naked_quiz_lifestylegoal:checked').each( function() {
          if(naked_quiz_lifestylegoal.includes($(this).val())) {
            recommended_products_lifestylegoal.push(product_handle);
            recommend_based_on_lifestylegoal = true;
          }
        });
      } else {
        recommend_based_on_lifestylegoal = true;
      }
      
      if(naked_quiz_athlete != '') {
        console.log(product_handle + ' has meta for naked_quiz_athlete: ' + naked_quiz_athlete);
        $('input.naked_quiz_athlete:checked').each( function() {
          if(naked_quiz_athlete.includes($(this).val())) {
            recommended_products_athlete.push(product_handle);
          } else {
            recommend_based_on_athlete = false;
          }
        });
      }
      
      if(naked_quiz_diet != '') {
        console.log(product_handle + ' has meta for naked_quiz_diet: ' + naked_quiz_diet);
        $('input.naked_quiz_diet:checked').each( function() {
          if(naked_quiz_diet.includes($(this).val())) {
            recommended_products_diet.push(product_handle);
          } else {
            recommend_based_on_diet = false;
          }
        });
      }
      
      if(naked_quiz_restriction != '') {
        console.log(product_handle + ' has meta for naked_quiz_restriction: ' + naked_quiz_restriction);
        $('input.naked_quiz_restriction:checked').each( function() {
          if(naked_quiz_restriction.includes($(this).val())) {
            recommended_products_restriction.push(product_handle);
          } else {
            recommend_based_on_restriction = false;
          }
        });
      }
      
      if(naked_quiz_flavor != '') {
        console.log(product_handle + ' has meta for naked_quiz_flavor: ' + naked_quiz_flavor);
        $('input.naked_quiz_flavor:checked').each( function() {
          if(naked_quiz_flavor.includes($(this).val())) {
            recommended_products_flavor.push(product_handle);
          } else {
            recommend_based_on_flavor = false;
          }
        });
      }
      
      if(recommend_based_on_age && recommend_based_on_gender && recommend_based_on_bodygoal && recommend_based_on_lifestylegoal && recommend_based_on_athlete && recommend_based_on_diet && recommend_based_on_restriction && recommend_based_on_flavor) {
        recommended_products.push(product_handle);
      }
      
    });
    
    console.log('recommended_products_age: ' + recommended_products_age);
    console.log('recommended_products_gender: ' + recommended_products_gender);
    console.log('recommended_products_bodygoal: ' + recommended_products_bodygoal);
    console.log('recommended_products_lifestylegoal: ' + recommended_products_lifestylegoal);
    console.log('recommended_products_athlete: ' + recommended_products_athlete);
    console.log('recommended_products_diet: ' + recommended_products_diet);
    console.log('recommended_products_restriction: ' + recommended_products_restriction);
    console.log('recommended_products_flavor: ' + recommended_products_flavor);
    
    console.log('recommended_products: ' + recommended_products);
    
    $('.recommendedProduct').hide().attr('data-recommended', false);
    
    var actual_products_to_recommend; /* for sending no recommended products to klaviyo if no actual recommended products */
    
    if(recommended_products.length > 0) {
      
      $('#recommendedProductsCopy-no-results').hide();
      $('#recommendedProductsCopy').show();
      
      var recommended_products_to_show = recommended_products;
      actual_products_to_recommend = true;
      
    } else {
      
      $('#recommendedProductsCopy').hide();
      $('#recommendedProductsCopy-no-results').show();
      
      var recommended_products_to_show = recommended_products_bodygoal;
      actual_products_to_recommend = false;
      
    }
    
    for(i in recommended_products_to_show) {
      var recommended_product_handle = recommended_products_to_show[i];
      var $recommended_product = $('#recommendedProduct-'+recommended_product_handle);
      var $recommended_product_image = $recommended_product.find('.naked-product-image');
      $recommended_product_image.attr('src', $recommended_product_image.attr('data-src'));
      if(actual_products_to_recommend) {
        $recommended_product.show().attr('data-recommended', true);
      } else {
        $recommended_product.show();
      }
    }
    
    setTimeout( function() {
      $naked_quiz.addClass('quiz-results-loaded');
    }, 2000);

    var resultsMeta = stepAnalyticsMeta('results');
    var recommendedCount = $('.recommendedProduct[data-recommended="true"]').length;
    var emailCaptured = $('#nakedQuiz').hasClass('klaviyo-form-submitted');
    analyticsCaptureOnce('results', 'Quiz Results Viewed', {
      step_name: resultsMeta.step_name,
      step_index: resultsMeta.step_index,
      recommended_count: recommendedCount,
      email_captured: emailCaptured,
      used_fallback: !actual_products_to_recommend,
      has_email: emailCaptured,
      has_phone: false,
    });
    
    /** Save certain quiz answers for use elsewhere on site, e.g. selecting bundle products (gender, diet) **/
    var canStore = (window.localStorage && typeof JSON != 'undefined');
    if(canStore){
      var customer_gender = $('input.naked_quiz_gender:checked').val();
      var customer_diet = $('input.naked_quiz_diet:checked').val();
      var customer_preferred_flavor = $('input.naked_quiz_flavor:checked').val();
      window.localStorage.setItem('customer_gender',customer_gender);
      window.localStorage.setItem('customer_diet',customer_diet);
      window.localStorage.setItem('customer_preferred_flavor',customer_preferred_flavor);
    }
    
  } /* end function load_quiz_results */
  
  function open_quiz() {
    $naked_quiz.removeClass('quiz-step--landing');
    if($('.nakedQuizKlaviyoForm').length > 0 && $('.nakedQuizKlaviyoForm').find('button').length > 0) {
      $('.nakedQuizKlaviyoForm').find('button').each( function() {
        var $button = $(this);
        if($button.text().includes('Results') || $button.text().includes('Submit')) {
          $button.addClass('button');
        }
      });
    }
  }
  
  function go_to_step(step_href) {
    
    $('.nakedQuizStep').removeClass('nakedQuizStep-active nakedQuizStep-previous');
    
    var next_step = step_href.replace('#',''),
        $next_step = $('#nakedQuizStep-'+next_step);
    
    window.location.hash = step_href;
    
    $next_step.addClass('nakedQuizStep-active');
    
    $naked_quiz.addClass('quiz-step--'+next_step);

    trackStepViewed(next_step);
    
    if(next_step == 'results') {
      $naked_quiz.addClass('quiz-steps-completed');
      load_quiz_results();
    }
    
  } /* end function go_to_step */
  
  function complete_step($step, options) {
    
    $step.addClass('nakedQuizStep-complete nakedQuizStep-previous');
    var prev_step_id = $step.attr('id'),
        prev_step_href = prev_step_id.replace('nakedQuizStep-', '#');
    $('.naked-quiz-action-back').attr('href', prev_step_href);
    // Skip analytics when restoring UI via auto_run_thru_quiz (deep-link/hash restore).
    if (!options || !options.skipAnalytics) {
      trackStepCompleted($step);
    }
    
  } /* end function complete_step */
  
  var error_message = "Please answer the question";
  
  function step_is_complete($step) {
    
    var $this_step_option_input = $step.find('.naked-option-input');
    var $this_step_text_input = $step.find('.naked-text-input-required');
    
    if($this_step_option_input.length > 0) {
      var $this_step_checked_option = $step.find('.naked-option-input:checked');
      if($this_step_checked_option.length < 1) {
        error_message = "Please make a selection";
        return false;
      }
    } else if($this_step_text_input.length > 0) {
      if(!$this_step_text_input.val()) {
        error_message = "Please answer the question";
        return false;
      }
    }
    
    return true;
    
  } /* end function step_is_complete */
  
  function auto_run_thru_quiz($last_completed_step) {
    open_quiz();
    var last_completed_step_id = $last_completed_step.attr('id');
    var reached_last_step = false;
    $('.nakedQuizStep').each( function() {
      var step_id = $(this).attr('id');
      if(step_id == last_completed_step_id) {
        reached_last_step = true;
      }
      if(!reached_last_step) {
        if(step_is_complete($(this))) {
          complete_step($(this), { skipAnalytics: true });
        }
      }
    });
  }
  
  var navigating_via_hash_change = true;
  
  $(window).bind('hashchange', function() {
    console.log('hash change');
    
    if(navigating_via_hash_change) {
      
      if(!window.location.hash || window.location.hash == '#landing') {
        $naked_quiz.addClass('quiz-step--landing');
        return;
      }
      
      open_quiz();

      var hash = window.location.hash,
          target_step = hash.replace('#','');

      console.log('target_step: '+target_step);

      var $target_step = $('#nakedQuizStep-'+target_step);
      if($target_step.hasClass('nakedQuizStep-disabled')) {
        $target_step = $target_step.prev('.nakedQuizStep').not('.nakedQuizStep-disabled');
      }
      var $target_step_prev = $target_step.prev('.nakedQuizStep');
      if($target_step.length > 0 && step_is_complete($target_step_prev)) {
        console.log('changing active step based on hash change');
        $('.nakedQuizStep').removeClass('nakedQuizStep-active');
        $target_step.addClass('nakedQuizStep-active');
        $target_step.prev('.nakedQuizStep').addClass('nakedQuizStep-previous');
        $target_step.next('.nakedQuizStep').removeClass('nakedQuizStep-previous');

        var prev_step_id = $target_step.prev('.nakedQuizStep').attr('id'),
            prev_step_href = prev_step_id.replace('nakedQuizStep-', '#');

        $('.naked-quiz-action-back').attr('href', prev_step_href);
        $naked_quiz.removeClass('quiz-loading-results quiz-results-loaded');
        trackStepViewed($target_step.attr('id').replace('nakedQuizStep-', ''));
        if(target_step == 'results') {
          $naked_quiz.addClass('quiz-steps-completed');
          load_quiz_results();
        }
      }
      
    }
    
    navigating_via_hash_change = true;
    
  });
  
  function auto_fill_quiz_for_testing() {
    $('.nakedQuizStep').each( function() {
      var $first_option = $(this).find('input.naked-option-input').first();
      if($first_option.length > 0) {
        console.log($first_option.attr('id'));
        $first_option.prop('checked', true);
      }
    });
    var step_to_go_to = 'question-9';
    setTimeout( function() {
      go_to_step('#'+step_to_go_to);
      auto_run_thru_quiz($('#nakedQuizStep-'+step_to_go_to));
    }, 500);
  }
  
  $(window).on('load', function() {
    if(window.location.hash) {
      var hash_on_load = window.location.hash;
      console.log('window loaded, hash: ' + hash_on_load);
      if(hash_on_load.includes('question-') || hash_on_load == '#results') {
        var target_step = hash_on_load.replace('#',''),
            $target_step = $('#nakedQuizStep-'+target_step);
        var $last_step_to_complete = $target_step.prev('.nakedQuizStep');
        if(hash_on_load == '#results') {
          $last_step_to_complete = $last_step_to_complete.prev('.nakedQuizStep');
        }
        if($target_step.length > 0 && step_is_complete($last_step_to_complete)) {
          go_to_step(hash_on_load);
          auto_run_thru_quiz($target_step);
        }
      }
      if(hash_on_load.includes('#auto413')) {
        auto_fill_quiz_for_testing();
      }
    } else {
      console.log('window loaded, no hash');
    }
  });
  
  $('.naked-quiz-action-start').on('click', function(e) {
    e.preventDefault();
    open_quiz();
    
    navigating_via_hash_change = false;
    
    var href = $(this).attr('href'),
        first_step = href.replace('#','');
    
    go_to_step(href);
    
  });
  
  $('.naked-quiz-action-next').on('click', function(e) {
    e.preventDefault();
    
    navigating_via_hash_change = false;
    
    var $this_step = $(this).parents('.nakedQuizStep');
    
    var href = $(this).attr('href');
    
    var $href_step = $('#nakedQuizStep-'+href.replace('#', ''));
    if($href_step.hasClass('nakedQuizStep-disabled')) {
      var $href_next_step = $href_step.next('.nakedQuizStep').not('.nakedQuizStep-disabled');
      href = $href_next_step.attr('id').replace('#nakedQuizStep-', '#');
    }
    
    if(step_is_complete($this_step)) {
      go_to_step(href);
      complete_step($this_step);
    } else {
      var errorStepId = ($this_step.attr('id') || '').replace('nakedQuizStep-', '');
      var errorMeta = stepAnalyticsMeta(errorStepId);
      analyticsCapture('Quiz Step Error', {
        step_name: errorMeta.step_name,
        step_index: errorMeta.step_index,
        error_reason: error_message,
      });
      alert(error_message);
    }
    
  });

  // Fire ATC analytics only after the cart item count increases (AJAX add success).
  // Queue supports rapid multi-product adds without overwriting earlier props.
  var pendingAtcQueue = [];
  var cartCountEl = document.getElementById('naked-cart-item-count');
  var lastCartCountText = cartCountEl ? String(cartCountEl.textContent || '') : '';

  function flushPendingAtcIfCountChanged() {
    if (!pendingAtcQueue.length || !cartCountEl) return;
    var next = String(cartCountEl.textContent || '');
    if (next === lastCartCountText) return;
    var prevNum = Number(lastCartCountText) || 0;
    var nextNum = Number(next) || 0;
    lastCartCountText = next;
    var delta = Math.max(1, nextNum - prevNum);
    while (delta > 0 && pendingAtcQueue.length) {
      var item = pendingAtcQueue.shift();
      if (!item) break;
      if (item.timeoutId) window.clearTimeout(item.timeoutId);
      analyticsCapture('Quiz Product Added To Cart', item.props);
      delta -= 1;
    }
  }

  if (cartCountEl && typeof MutationObserver !== 'undefined') {
    new MutationObserver(flushPendingAtcIfCountChanged).observe(cartCountEl, {
      childList: true,
      characterData: true,
      subtree: true,
    });
  }

  $(document).on('submit', '#recommendedProducts form[action*="/cart/add"]', function () {
    var $form = $(this);
    var $card = $form.closest('.recommendedProduct');
    var resultsMeta = stepAnalyticsMeta('results');
    var variantInput = $form.find('input[name="id"]').val();
    if (cartCountEl) lastCartCountText = String(cartCountEl.textContent || '');
    var entry = {
      props: {
        step_name: resultsMeta.step_name,
        step_index: resultsMeta.step_index,
        product_id: null,
        variant_id: variantInput ? Number(variantInput) || variantInput : null,
        product_handle: $card.attr('data-product-handle') || null,
        product_title: $card.attr('data-product-title') || null,
        was_recommended: $card.attr('data-recommended') === 'true',
      },
      timeoutId: null,
    };
    // Drop this pending capture if the add never updates the cart count.
    entry.timeoutId = window.setTimeout(function () {
      var idx = pendingAtcQueue.indexOf(entry);
      if (idx !== -1) pendingAtcQueue.splice(idx, 1);
    }, 8000);
    pendingAtcQueue.push(entry);
  });

  $(document).on('click', '.naked-quiz-action-checkout', function () {
    var resultsMeta = stepAnalyticsMeta('results');
    analyticsCapture('Quiz Checkout Clicked', {
      step_name: resultsMeta.step_name,
      step_index: resultsMeta.step_index,
      cart_item_count: Number($('#naked-cart-item-count').text()) || 0,
    });
  });
  
 $('.stepOptions label').keypress(function(event){var keycode = (event.keyCode ? event.keyCode : event.which);if(keycode == '13' || keycode == '32'){$(this).click();}});

 $('.stepOptions label').keypress(function (event) {
	var keycode = (event.keyCode ? event.keyCode : event.which);
	if (keycode == '13' || keycode == '32') {
		$(this).click();
	}
 });                                                                      
                                                                            
  $('.naked-option-reset').on('change', function() {
    var $this = $(this);
    if($this.is(':checked')) {
      var $parent_step = $this.parents('.nakedQuizStep');
      $parent_step.find('.naked-option-input').not($this).prop('checked', false);
    }
  });
  
  $('.naked-option-input').not('.naked-option-reset').on('change', function() {
    var $parent_step = $(this).parents('.nakedQuizStep');
    var $step_reset_option = $parent_step.find('.naked-option-reset');
    if($step_reset_option.length > 0) {
      $step_reset_option.prop('checked', false);
    }
  });
  
  
  $('.triggerWhyDoWeAskThis').on('click', function(e) {
    e.preventDefault();
    var target = $(this).attr('href'),
        $target = $(target);
    $target.toggleClass('visible');
    var ariaAttr = $(this).attr('aria-expanded');
    ariaAttr == 'true' ? ariaAttr = false : ariaAttr = true;
    this.setAttribute('aria-expanded', ariaAttr);
  });
  
  $('.naked-quiz-action-exit').on('click', function(e) {
    var referrer = document.referrer;
    if(!referrer.includes('nakednutrition.com')) {
      e.preventDefault();
      console.log(referrer);
      window.location.href = 'https://nakednutrition.com';
    }
  });
  
  function copyText(element_id) {
    var element = document.getElementById(element_id);
    var range, selection, worked;

    if (document.body.createTextRange) {
      range = document.body.createTextRange();
      range.moveToElementText(element);
      range.select();
    } else if (window.getSelection) {
      selection = window.getSelection();        
      range = document.createRange();
      range.selectNodeContents(element);
      selection.removeAllRanges();
      selection.addRange(range);
    }

    try {
      document.execCommand('copy');
      console.log('text copied');
      return true;
    }
    catch (err) {
      console.log('unable to copy text');
      return false;
    }
  }

  $('.action-copy-text').on('click', function() {
    var element_id = $(this).attr('id');
    if(copyText(element_id)) {
      $(this).addClass('textCopied');
    }
  });
  
  $('.autoForTesting').on('click', function() {
    auto_fill_quiz_for_testing();
  });
  
}); /* End document.ready */
